export default "__VITE_ASSET__v5c0zmBR__"